import { STEPS } from "../config/brand";
import { FadeUp, LineReveal } from "../components/Reveal";

export const HowItWorks = () => (
  <section
    id="how-it-works"
    className="scroll-mt-20 bg-blushcream/60"
    aria-label="How it works"
    data-testid="how-it-works-section"
  >
    <div className="mx-auto max-w-[1280px] px-5 py-20 sm:px-8 lg:py-28">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <LineReveal
            as="h2"
            lines={["Use the system", "your way."]}
            className="font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl"
          />
          <FadeUp delay={0.15}>
            <p className="mt-5 text-base leading-relaxed text-plumcharcoal/75">
              There's no order to follow and nothing to finish. You don't need
              to complete all nine resources—you just need the one that helps
              today.
            </p>
          </FadeUp>
        </div>
        <div className="lg:col-span-8">
          <ol className="space-y-5">
            {STEPS.map((s, i) => (
              <FadeUp key={s.number} delay={i * 0.08}>
                <li
                  data-testid={`step-${s.number}`}
                  className="group flex gap-6 rounded-3xl border border-mauve/35 bg-warmwhite p-7 shadow-[0_8px_30px_rgba(90,48,73,0.04)] transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_44px_rgba(90,48,73,0.09)] sm:p-9"
                >
                  <span className="font-serif text-4xl italic leading-none text-rose/70 transition-colors group-hover:text-rose sm:text-5xl">
                    {s.number}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl font-semibold tracking-tight text-plum">
                      {s.title}
                    </h3>
                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-plumcharcoal/70 sm:text-base">
                      {s.text}
                    </p>
                  </div>
                </li>
              </FadeUp>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);
